import { render, staticRenderFns } from "./AddTrainingModal.vue?vue&type=template&id=5b700f24&scoped=true&"
import script from "./AddTrainingModal.vue?vue&type=script&lang=js&"
export * from "./AddTrainingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b700f24",
  null
  
)

export default component.exports